module.exports = __webpack_public_path__ + "static/media/10_3.60c134f2.png";